export default "__VITE_ASSET__Dl6l04Rh__"